import { useState } from 'react';
import Button from '@mui/material/Button';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import styles from './NewReport.module.css';

const NAME_MAX = 130;
const DESC_MAX = 250;

export default function NewReport(props) {
  const [helperText, setHelperText] = useState({});
  const [errorMessage, setErrorMessage] = useState({});

  const handleBlur = (event) => {
    const newHelperText = { ...helperText };
    const newError = { ...errorMessage };
    if (event.target.value.trim() === '') {
      newHelperText[event.target.name] = 'El campo no puede ir vacío';
      newError[event.target.name] = true;
    } else {
      newHelperText[event.target.name] = '';
      newError[event.target.name] = false;
    }
    setErrorMessage(newError);
    setHelperText(newHelperText);
  };

  const handleSubmit = () => {
    const errors = {};
    const texts = {};
    if (!props.info.name || props.info.name.trim() === '') {
      errors.name = true;
      texts.name = 'El campo no puede ir vacío';
    }
    if (!props.info.descripcion || props.info.descripcion.trim() === '') {
      errors.descripcion = true;
      texts.descripcion = 'El campo no puede ir vacío';
    }
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setHelperText(texts);
      return;
    }
    props.handleAddReport();
  };

  const handleChangeReport = (event) => {
    const { name, value } = event.target;
    const max = name === 'name' ? NAME_MAX : DESC_MAX;
    if (value.length <= max) {
      props.handleChangeReport(event);
    }
  };

  const nameCount = (props.info.name || '').length;
  const descCount = (props.info.descripcion || '').length;

  return (
    <div className={styles.form}>
      <div className={styles.input}>
        <div style={{ flexBasis: '85.5%' }}>
          <TextField
            id="outlined-name"
            label="Name"
            value={props.info.name}
            name="name"
            onChange={handleChangeReport}
            fullWidth
            error={errorMessage.name}
            helperText={helperText.name}
            size="small"
            onBlur={handleBlur}
            inputProps={{ maxLength: NAME_MAX }}
          />
          <Typography
            variant="caption"
            color={nameCount >= NAME_MAX ? 'error' : 'text.secondary'}
            sx={{ display: 'block', textAlign: 'right', mt: 0.5 }}
          >
            {nameCount}/{NAME_MAX}
          </Typography>
        </div>
      </div>
      <div className={styles.input}>
        <div style={{ width: '85.5%' }}>
          <TextareaAutosize
            aria-label="empty textarea"
            placeholder="Descripción..."
            style={{
              width: '100%',
              height: '100px',
              marginTop: '0.5rem',
              boxSizing: 'border-box',
              borderColor: errorMessage.descripcion ? '#d32f2f' : undefined,
              outline: errorMessage.descripcion ? '1px solid #d32f2f' : undefined,
            }}
            name="descripcion"
            value={props.info.descripcion}
            onChange={handleChangeReport}
            onBlur={handleBlur}
          />
          {errorMessage.descripcion && (
            <Typography variant="caption" color="error" sx={{ display: 'block', mt: 0.5 }}>
              {helperText.descripcion}
            </Typography>
          )}
          <Typography
            variant="caption"
            color={descCount >= DESC_MAX ? 'error' : 'text.secondary'}
            sx={{ display: 'block', textAlign: 'right' }}
          >
            {descCount}/{DESC_MAX}
          </Typography>
        </div>
      </div>
      <div className={styles.impexp}>
        <Button variant="text" onClick={props.handleCloseModal}>
          Cancelar
        </Button>
        <Button variant="contained" onClick={handleSubmit}>
          Aceptar
        </Button>
      </div>
    </div>
  );
}
